import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { primary_dark15 } from '../../shared/lib/colors';
import { css } from '@emotion/core';
import { FaChevronUp } from 'react-icons/fa';
import A from '../../shared/Anchor/Anchor';
import Link from '../../shared/Link/Link';
import {
  getCategoryType,
  getCategoriesByType,
} from '../../../redux/modules/categories';
import './LeftFilters.scss';

class FiltriCategoria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showOrderByFilter: true,
      showCategoryFilter: !this.props.tag,
      showAttributeFilter: !!this.props.tag,
      openCategory: '',
    };
  }

  toggleOrderByFilter = event => {
    event.preventDefault();
    this.setState({
      showOrderByFilter: !this.state.showOrderByFilter,
    });
  };

  toggleCategoryFilter = event => {
    event.preventDefault();
    this.setState({
      showCategoryFilter: !this.state.showCategoryFilter,
    });
  };

  toggleAttributeFilter = event => {
    event.preventDefault();
    this.setState({
      showAttributeFilter: !this.state.showAttributeFilter,
    });
  };

  // OPEN CATEGORIES
  setOpenCategory = category => event => {
    event.preventDefault();

    const { openCategory } = this.state;

    if (openCategory !== category) {
      this.setState({
        openCategory: category,
      });
    } else {
      this.setState({
        openCategory: '',
      });
    }
  };

  onLinkClick = event => {
    this.setState({
      openCategory: '',
    });
  };

  renderSubcategories(category) {
    const { type } = this.props;

    return category.subcategories.map(subcategory => {
      return (
        <li
          key={subcategory.seoName}
          className={
            subcategory.seoName === this.props.subcategory ? 'active' : ''
          }
        >
          <Link
            to={`/${category.type}/${category.seoName}/${subcategory.seoName}`}
            onClick={this.onLinkClick}
          >
            {subcategory.name}{' '}
            <span className="products-number">
              ({subcategory.productsNumber})
            </span>
          </Link>
        </li>
      );
    });
  }

  renderCategories() {
    const { categories, type } = this.props;

    return categories.map(category => {
      return (
        <li
          key={category.seoName}
          className={
            category.seoName === this.state.openCategory ||
            category.seoName === this.props.category
              ? 'active'
              : ''
          }
        >
          {category.subcategories && category.subcategories.length > 0 ? (
            <div>
              <A href="#" onClick={this.setOpenCategory(category.seoName)}>
                {category.name}{' '}
                <span className="products-number">
                  ({category.productsNumber})
                </span>
              </A>
              <ul className="subcategories">
                {this.renderSubcategories(category)}
              </ul>
            </div>
          ) : (
            <Link
              to={`/${category.type}/${category.seoName}`}
              onClick={this.onLinkClick}
            >
              {category.name}{' '}
              <span className="products-number">
                ({category.productsNumber})
              </span>
            </Link>
          )}
        </li>
      );
    });
  }

  renderTags() {
    const { tags } = this.props;

    return tags.map(tag => {
      return (
        <li
          key={tag.id}
          className={tag.seoName === this.props.tag ? 'active' : ''}
        >
          <Link to={`/tag/${tag.seoName}`} onClick={this.onLinkClick}>
            {tag.name}{' '}
            <span className="products-number">({tag.productsNumber})</span>
          </Link>
        </li>
      );
    });
  }

  render() {
    let {
      showOrderByFilter,
      showCategoryFilter,
      showAttributeFilter,
    } = this.state;
    let { location, primaryColor, hasDoofinder } = this.props;

    const getLocation = sort => {
      return {
        pathname: location.pathname,
        query: { sort },
      };
    };

    const filterStyle = css`
      .nav > li {
        a {
          &:focus,
          &:hover {
            color: ${primary_dark15(primaryColor)};
          }
        }
        &.active {
          a {
            color: ${primaryColor};
          }
        }
        ul.subcategories > li {
          a {
            &:focus,
            &:hover {
              color: ${primary_dark15(primaryColor)};
            }
          }
          &.active {
            a {
              color: ${primaryColor};
            }
          }
        }
      }
    `;

    return (
      <div className="left-filters">
        {!hasDoofinder && (
          <>
            <aside
              className={`filter ${showOrderByFilter ? 'filter-open' : ''}`}
              css={filterStyle}
            >
              <A
                href="#"
                className="toggle-filter-link"
                onClick={this.toggleOrderByFilter}
              >
                <h2>Ordina per</h2>
                <div className="toggle-filter">
                  <FaChevronUp />
                </div>
              </A>
              <ul className="nav">
                <li className={this.props.sort === '-sales' ? 'active' : ''}>
                  <Link to={getLocation('sales')}>Più acquistati</Link>
                </li>
                <li className={this.props.sort === '-date' ? 'active' : ''}>
                  <Link to={getLocation('date')}>Ultimi arrivi</Link>
                </li>
                <li
                  className={this.props.sort === '-discounted' ? 'active' : ''}
                >
                  <Link to={getLocation('discounted')}>In offerta</Link>
                </li>
                <li className={this.props.sort === '-price' ? 'active' : ''}>
                  <Link to={getLocation('-price')}>Prezzo più alto</Link>
                </li>
                <li className={this.props.sort === 'price' ? 'active' : ''}>
                  <Link to={getLocation('price')}>Prezzo più basso</Link>
                </li>
              </ul>
            </aside>

            <hr />
          </>
        )}
        <nav
          className={`filter ${showCategoryFilter ? 'filter-open' : ''}`}
          css={filterStyle}
        >
          <A
            href="#"
            className="toggle-filter-link"
            onClick={this.toggleCategoryFilter}
          >
            <h2>Categorie</h2>
            <div className="toggle-filter">
              <FaChevronUp />
            </div>
          </A>
          <ul className="nav">{this.renderCategories()}</ul>
        </nav>

        <hr />

        {this.props.tags && !!this.props.tags.length && (
          <nav
            className={`filter ${showAttributeFilter ? 'filter-open' : ''}`}
            css={filterStyle}
          >
            <A
              href="#"
              className="toggle-filter-link"
              onClick={this.toggleAttributeFilter}
            >
              <h2>Attributi</h2>
              <div className="toggle-filter">
                <FaChevronUp />
              </div>
            </A>
            <ul className="nav">{this.renderTags()}</ul>
          </nav>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const type = getCategoryType(state, ownProps.category);
  return {
    storeId: state.store.data.storeId,
    hasDoofinder: state.store.data.features.hasDoofinder,
    categories: getCategoriesByType(state, type),
    tags: state.tags.data,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
}

export default connect(mapStateToProps, {})(withRouter(FiltriCategoria));
